import Backbone from 'backbone';
import _ from 'underscore';
import LayerModel from './models/LayerModel';

let BaseLayer = Backbone.View.extend(
  /**@lends core.layers.base.BaseLayer.prototype */
  {
    /**
     *
     * Create a BaseLayer instance. Shouldn't be used directly as this class exists just to provide base functionality.
     * @memberof core.layers.base
     * @class BaseLayer
     * @classdesc
     * @extends Backbone.View
     * @abstract
     * @param {object} options - The needed config to draw the layer on map
     * @listens LayerModel#change:active
     */
    constructor(options) {
      this.widget = options.widget;
      this.options = options;
      this._initModel();
      this._bindModelEvents();
      Backbone.View.prototype.constructor.call(this, options);
    },

    _initModel() {
      let model = this.widget.handleLayers.getLayerModel(this.options.id);
      let id = this.options.id || _.uniqueId();
      if (_.isUndefined(model)) {
        let ModelClass = this.options.ModelClass || LayerModel;
        model = new ModelClass({
          id: id,
          active: this.options.active === true || false,
          visible: this.options.active && this.isAvailableZoom(),
          index: this.options.index
        });
        this.widget.handleLayers.layersCollection.add(model);
      }
      this.options.model = model;
    },

    _bindModelEvents() {
      this.listenTo(this.options.model, 'change:active', (object, active) => {
        if (active) {
          this.add();
        } else {
          this.remove();
        }
        if (this.options.notify) {
          this._notify(active ? 'showlayer' : 'hidelayer', {
            layer: object.id
          });
        }
      });

      this.listenTo(this.options.model, 'change:visible', (object, visible) => {
        if (visible) {
          this.show();
        } else {
          this.hide();
        }
      });
    },

    /**
     * This method will be overrided in order to add the layer on map
     * @function
     * @abstract
     * @throws {Error} The method needs an implementation in the extending class
     */
    add() {
      throw new Error('BaseLayer::add method needs an implementation in the extending class');
    },

    /**
     * This method will be overrided in order to remove the layer from map
     * @function
     * @abstract
     * @throws {Error} The method needs an implementation in the extending class
     */
    remove() {
      throw new Error('BaseLayer::remove method needs an implementation in the extending class');
    },

    /**
     * Check if the current zoom level is bigger than the minimun zoom level of layer
     * @returns {boolean} If layer will be visible on this zoom level
     */
    isAvailableZoom() {
      return this.widget.map.getZoom() >= this.options.minZoom;
    }
  });

export default BaseLayer;



// WEBPACK FOOTER //
// ./lmm-widget/src/layers/types/_base/BaseLayer.js